import { render } from "./SingleItemCreationComponent.vue?vue&type=template&id=31f0050a"
import script from "./SingleItemCreationComponent.vue?vue&type=script&lang=js"
export * from "./SingleItemCreationComponent.vue?vue&type=script&lang=js"

import "./SingleItemCreationComponent.vue?vue&type=style&index=0&id=31f0050a&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__